import { gql } from '@apollo/client'

export const SYNC_JURNODES_MUTATION = gql`
  mutation SyncJurnodes($caseId: ID!, $userIdentifier: Int) {
    syncJurnodes(caseId: $caseId, userIdentifier: $userIdentifier)
  }
`
